import { useEffect, useState } from "react";
import { getAreaList, getListArea } from "../../../API/Lists/area";
import { getIndustryTypeList } from "../../../API/Lists/industryType";
import { getHierarchicalLevelList } from "../../../API/Lists/hierarchicalLevel";
import { getCandidateProfesionalExperiences, patchCandidateProfesionalExperiences } from "../../../API/Candidates/Experience";
import { firstLoginTranslate } from "../../../i18n/translatedMessages";
import { useIntl } from "react-intl";
import { translate as hierarchicalTranslate } from "../../../i18n/messages/Lists/hierarchicalLevel";
import CustomInput from "../components/customInput";
import CustomSelect from "../components/customSelect";
import CustomCheckBox from "../components/customCheckBox";
import CustomDateInput from "../components/customDateInput";
import Swal from "sweetalert2";
import Loading from "../../../Components/Loading/Loading";

const Step1FirstLogin = ({ onNextStep }) => {
  const locale = useIntl().locale;
  const language = locale === "PT-BR" ? "pt" : "es";
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({
    company: "",
    jobname: "",
    entry_date: "2000-01-01",
    description: "",
    area_id: 0,
    hierarchical_level_id: 0,
    industry_id: 0,
    departure_date: "2000-01-01",
  });
  const [checkBoxValue, setCheckBoxValue] = useState(false);
  const [areaList, setAreaList] = useState();
  const [industryList, setIndustryList] = useState();
  const [hierarchicalList, setHierarchicalList] = useState([]);

  const isFormValid = () => {
    return (
      data.company === "" ||
      data.jobname === "" ||
      data.entry_date === "" ||
      data.area_id === "0" ||
      data.hierarchical_level_id === "0" ||
      data.industry_id === "0" ||
      data.area_id === 0 ||
      data.hierarchical_level_id === 0 ||
      data.industry_id === 0 ||
      data.departure_date === "" ||
      data.departure_date === false ||
      data.departure_date < data.entry_date
    );
  };

  useEffect(() => {
    const fetchList = async () => {
      const [areaList, industryList, hierichicalList, professionalHistory] = await Promise.all([
        getListArea(),
        getIndustryTypeList(),
        getHierarchicalLevelList(),
        getCandidateProfesionalExperiences(localStorage.getItem("candidateId")),
      ]);
      setAreaList(areaList);
      setIndustryList(industryList);
      setHierarchicalList(hierichicalList);
      setData((prevData) => ({
        ...prevData,
        ...(professionalHistory.items?.professional_experiences?.[0] || {}),
      }));
      setIsLoading(false);
    };

    fetchList();
  }, []);

  const handleChangeCheckBox = (e) => {
    const { name, checked } = e.target;
    setCheckBoxValue(checked);

    if (checked) {
      setData((prevData) => ({
        ...prevData,
        departure_date: "Actual",
      }));
    } else {
      setData((prevData) => ({
        ...prevData,
        departure_date: false,
      }));
    }
  };

  const handleStartClick = async () => {
    setIsLoading(true);
    const sendData = {
      company: data.company,
      jobname: data.jobname,
      entry_date: data.entry_date,
      description: data.description,
      area_id: Number(data.area_id),
      hierarchical_level_id: Number(data.hierarchical_level_id),
      industry_id: Number(data.industry_id),
      departure_date: data.departure_date === true ? "Actual" : data.departure_date,
    };

    const resp = await patchCandidateProfesionalExperiences(
      [{ ...sendData, departure_date: sendData.departure_date === true ? "Actual" : sendData.departure_date }],
      localStorage.getItem("candidateId")
    );

    if (resp.status === 200) {
      onNextStep();
    } else {
      setIsLoading(false);
      Swal.fire({
        title: "Hola 👋",
        text: "Algo ha ido mal, inténtalo más tarde!",
        icon: "info",
        confirmButtonText: "Ok",
      });
    }
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.type === "checkbox" ? event.target.checked : event.target.value;
    setData({
      ...data,
      [name]: value,
    });
  };

  const hierarchicalTranslated = hierarchicalList.map((item) => ({
    ...item,
    value: hierarchicalTranslate[language][item?.level],
  }));

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <div className=" me-5 text-white w-100">
          <div className="mb-3" style={{ color: "#41C8FF" }}>
            Etapa 1 de 3
          </div>
          <h3>
            <strong>{firstLoginTranslate.step1FirstLogin}</strong>
          </h3>
          <div className="mb-3 text-gray">{firstLoginTranslate.step1FirstLoginText}</div>

          <div className="step3-form p-0 mt-5">
            <div className="mb-5 row">
              <div className="col">
                <CustomInput label={firstLoginTranslate.step1Company} value={data.company} name={"company"} onChange={handleChange} />
              </div>
              <div className="col">
                <CustomSelect
                  label={firstLoginTranslate.step1Industry}
                  name={"industry_id"}
                  value={data.industry_id}
                  list={industryList}
                  propriety={language === "pt" ? "translate" : "name"}
                  onChange={handleChange}
                />
              </div>
              <div className="col">
                <CustomInput label={firstLoginTranslate.step1Position} value={data.jobname} name={"jobname"} onChange={handleChange} />
              </div>
            </div>
            <div className="mb-5 row">
              <div className="col">
                <CustomSelect
                  label={firstLoginTranslate.step1HierarchicalLevel}
                  name={"hierarchical_level_id"}
                  value={data.hierarchical_level_id}
                  list={hierarchicalTranslated}
                  propriety={"value"}
                  onChange={handleChange}
                />
              </div>
              <div className="col">
                <CustomSelect
                  label={firstLoginTranslate.step1Area}
                  name={"area_id"}
                  value={data.area_id}
                  list={areaList}
                  propriety={language === "pt" ? "area_brasil" : "area"}
                  onChange={handleChange}
                />
              </div>
              <div className="col">
                <CustomCheckBox
                  title={firstLoginTranslate.step1Working}
                  label={language === "pt" ? "Sim" : "Sí"}
                  value={data.departure_date === "Actual" ? true : false}
                  name={"departure_date"}
                  onChange={handleChangeCheckBox}
                />
              </div>
            </div>
            <div className="mb-5 row">
              <div className={`${data.departure_date === "Actual" || data.departure_date === true || data.departure_date !== "" ? "col-4" : "col"}`}>
                <CustomDateInput value={data.entry_date} label={firstLoginTranslate.step1StartDate} name={"entry_date"} onChange={handleChange} />
              </div>
              {data.departure_date !== "Actual" && (
                <div className="col">
                  <CustomDateInput label={firstLoginTranslate.step1EndDate} value={data.departure_date} name={"departure_date"} onChange={handleChange} />
                </div>
              )}
              <div className="col" />
            </div>
          </div>
          <button className="custom-btn mt-5" disabled={isFormValid()} style={{ backgroundColor: isFormValid() ? "gray" : "" }} onClick={handleStartClick}>
            {firstLoginTranslate.firstLoginBtn}
          </button>
        </div>
      )}
    </>
  );
};

export default Step1FirstLogin;
